import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { TaxGuide } from '@/pages/TaxGuide';
import { NotFoundComponent } from '@/ui/templates/NotFound/NotFoundComponent';

export const Route = createFileRoute('/_pathlessRoute/$companyName')({
  loader: ({ params }) => {
    return params;
  },
  component: () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { companyName, ad } = Route.useParams();
    if (!companyName) return <NotFoundComponent />;
    return (
      <TaxGuide
        userId={companyName}
        templateType={'custom'}
        ad={ad ? 1 : null}
      />
    );
  },
});
